module.exports = __webpack_public_path__ + "img/rightbicep-endomorph-male.f214f07f.svg";